<template>
  <div class="country-data section">
    <h1 class="title">Country data</h1>

    <div class="box">
      <data-point-form :countries="countries"
        :data-point="newDataPoint"
        :regions="regions"
        :years="years"
        :people="people">
      </data-point-form>
    </div>

    <div>
      <div v-for="dataPoint in countryDataPoints" class="box" @click="openEdit(dataPoint.key)">
        <strong>{{dataPoint.region}} - {{dataPoint.year}}</strong>
        {{dataPoint.countryKey}}
        ({{dataPoint | quotaOver}} tonnes -
        {{dataPoint | percentOver}})
        <div :class="['modal', {'is-active': (dataPoint.key == openModalKey)}]">
          <div class="modal-background" @click="closeEdit"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">Edit data point</p>
              <button class="delete" @click="closeEdit"></button>
            </header>
            <section class="modal-card-body">
              <data-point-form
                :data-point="dataPoint"
                :countries="countries"
                :regions="regions"
                :years="years"
                :people="people">
              </data-point-form>
            </section>
            <footer class="modal-card-foot">
              <a class="button is-primary">Save</a>
              <a class="button" @click="closeEdit">Cancel</a>
            </footer>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'underscore'
import fb from 'firebase'
import DataPointForm from '../components/DataPointForm'

export default {
  components: {
    DataPointForm
  },
  data: function() {
    return {
      countryDataPoints: [],
      openModalKey: false,
      countries: [],
      years: [],
      regions: [],
      people: [],
      newDataPoint: {
        region: 0,
        year: 2014
      }
    }
  },
  ready: function() {
    let self = this
    this.fetchYears()
    this.fetchCountries()
    this.fetchPeople()
    this.fetchRegions()

    fb.database().ref('countryDataPoints').on('child_added', function(snapshot) {
      let dataPoint = snapshot.val()
      dataPoint.key = snapshot.key
      self.countryDataPoints.push(dataPoint)
      console.log(self.countryDataPoints)
    })
  },
  methods: {
    openEdit: function(key) {
      this.openModalKey = key
    },
    closeEdit: function(e) {
      e.cancelBubble = true
      this.openModalKey = false
    },
    fetchCountries: function() {
      let self = this

      fb.database().ref('countries').on('child_added', function(snapshot) {
        let country = snapshot.val()
        country.key = snapshot.key
        self.countries.push(country)
      })
    },

    fetchPeople: function() {
      let self = this

      fb.database().ref('people').on('child_added', function(snapshot) {
        let person = snapshot.val()
        person.key = snapshot.key
        self.people.push(person)
      })
    },

    fetchRegions: function() {
      let self = this

      fb.database().ref('regions').on('child_added', function(snapshot) {
        let region = snapshot.key
        self.regions.push(region)
      })
    },

    fetchYears: function() {
      let self = this

      fb.database().ref('periods').on('child_added', function(snapshot) {
        self.years.push(snapshot.key)
      })
    }
  }
}
</script>

<style scoped>
.modal-card {
  width: 910px !important;
}
.box {
  cursor: pointer
}
</style>



/** WEBPACK FOOTER **
 ** CountryDataPoints.vue?1e155db6
 **/